import slice from "./rangeOpportunitiesSlice";

export default slice.reducer;
